import { gql } from '@apollo/client'

const publicListingDetails = gql`
  fragment publicListingDetails on PublicListing {
    id
    hash
    status
    description
    isSecureSwapAvailable
    numberOfTicketsStillForSale
    numberOfTicketsInListing
    tickets(first: 99) {
      edges {
        node {
          id
          status
          seating {
            id
            entrance
            section
            row
            seat
          }
        }
      }
    }
  }
`

export default publicListingDetails
